// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Salary slip PDF viewer (SalarySlip.jsx) */
.salary-slip-view {
  width: 100%;
  max-width: 960px;
  margin: var(--ds-space-4) auto 0;
}

.salary-slip-view .salary-slip-view__title {
  overflow-wrap: anywhere;
  white-space: normal;
}

[dir="rtl"] .salary-slip-view .salary-slip-view__back svg {
  transform: scaleX(-1);
}

.salary-slip-view .salary-slip-view__actions {
  padding: var(--ds-space-3) var(--ds-space-4);
  border-bottom: 1px solid var(--ds-border-soft);
}

.salary-slip-view .salary-slip-view__loading {
  height: 480px;
}

.salary-slip-view .salary-slip-view__empty {
  padding: var(--ds-space-8) var(--ds-space-4);
}

/* The PDF keeps its own print layout; the frame only takes the width it is given. */
.salary-slip-view .salary-slip-view__frame {
  display: block;
  width: 100%;
  height: calc(100vh - 240px);
  min-height: 640px;
  border: 0;
}

@media (max-width: 767.98px) {
  .salary-slip-view {
    margin-top: 0;
  }

  .salary-slip-view .salary-slip-view__actions > .ant-btn {
    flex: 1 1 0;
  }

  .salary-slip-view .salary-slip-view__frame {
    height: calc(100dvh - 220px);
    min-height: 420px;
  }
}

@media (min-width: 768px) {
  .salary-slip-view {
    margin-top: var(--ds-space-8);
  }
}
`, "",{"version":3,"sources":["webpack://./src/commons/Employees/SalarySlips/SalarySlip.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,WAAW;EACX,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,oFAAoF;AACpF;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF","sourcesContent":["/* Salary slip PDF viewer (SalarySlip.jsx) */\n.salary-slip-view {\n  width: 100%;\n  max-width: 960px;\n  margin: var(--ds-space-4) auto 0;\n}\n\n.salary-slip-view .salary-slip-view__title {\n  overflow-wrap: anywhere;\n  white-space: normal;\n}\n\n[dir=\"rtl\"] .salary-slip-view .salary-slip-view__back svg {\n  transform: scaleX(-1);\n}\n\n.salary-slip-view .salary-slip-view__actions {\n  padding: var(--ds-space-3) var(--ds-space-4);\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n.salary-slip-view .salary-slip-view__loading {\n  height: 480px;\n}\n\n.salary-slip-view .salary-slip-view__empty {\n  padding: var(--ds-space-8) var(--ds-space-4);\n}\n\n/* The PDF keeps its own print layout; the frame only takes the width it is given. */\n.salary-slip-view .salary-slip-view__frame {\n  display: block;\n  width: 100%;\n  height: calc(100vh - 240px);\n  min-height: 640px;\n  border: 0;\n}\n\n@media (max-width: 767.98px) {\n  .salary-slip-view {\n    margin-top: 0;\n  }\n\n  .salary-slip-view .salary-slip-view__actions > .ant-btn {\n    flex: 1 1 0;\n  }\n\n  .salary-slip-view .salary-slip-view__frame {\n    height: calc(100dvh - 220px);\n    min-height: 420px;\n  }\n}\n\n@media (min-width: 768px) {\n  .salary-slip-view {\n    margin-top: var(--ds-space-8);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
